/*global google*/
export default class DMVOfficesMap {
  /**
   *
   * @param {String} el
   * @param {Array} offices
   * @param {Integer} zoom
   */
  constructor(el = '#map', offices = null, zoom = 10) {
    this.el = el;
    this.offices = offices || window.offices;
    this.markers = [];
    this.zoom = zoom;
  }

  /**
   * Render the map with its markers.
   */
  render() {
    const firstOffice = this.offices[0];
    this.map = new google.maps.Map(document.querySelector(this.el), {
      center: { lat: parseFloat(firstOffice.latitude), lng: parseFloat(firstOffice.longitude) },
      zoom: this.zoom,
    });

    this.infoWindow = new google.maps.InfoWindow;

    this.offices.forEach(office => {
      const content = `
        <h5>${office.title}</h5>
        <p>${office.street} <br> ${office.city}, ${office.state.name} ${office.zip}</p>
        <p><a href="${office.link}">See location details</a></p>
      `;
      const marker = new google.maps.Marker({
        position: { lat: parseFloat(office.latitude), lng: parseFloat(office.longitude) },
        map: this.map,
        id: office.id,
        title: office.title,
        link: office.link,
        animation: google.maps.Animation.DROP,
        infoWindowContent: content,
      });
      marker.addListener('click', () => {
        this.infoWindow.setContent(content);
        this.infoWindow.open(this.map, marker);
      });
      this.markers.push(marker);
    });
  }

  /**
   * Get the map instance.
   */
  getMap() {
    return this.map;
  }

  /**
   * Get all markers printed on the map
   */
  getMarkers() {
    return this.markers;
  }
}



// WEBPACK FOOTER //
// ./scripts/services/DMVOfficesMap.js